if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewed extends customElements.get(
    'card-product-slider'
  ) {
    constructor() {
      super();

      this.section = this.closest('.js-section');
      this.sliderWrapper = this.querySelector('.swiper-wrapper');
      this.productHandle = this.dataset.productHandle;

      this.fetchRecentProducts();

      if (document.querySelector("quick-cart-drawer") && this.querySelector('.swiper-slide')) {
        document.querySelector("quick-cart-drawer").init();
      }

      if (Shopify.designMode) {
        if (document.querySelector("quick-cart-drawer") && this.querySelector('.swiper-slide')) {
          document.querySelector("quick-cart-drawer").init();
        }
      }
    }

    removeHandleFromStorage(productHandle) {
      const productHandles = localStorage.getItem('recently-viewed');

      if (!productHandles) return;

      const updatedProductHandles = productHandles
        .replace(`${productHandle},`, '')
        .replace(productHandle, '');

      localStorage.setItem('recently-viewed', updatedProductHandles);
    }

    fetchRecentProducts() {
      const productHandles = localStorage.getItem('recently-viewed');

      if (!productHandles) {
        return;
      }

      const productHandlesArray = productHandles
        .split(',')
        .filter(
          productHandle =>
            productHandle &&
            productHandle !== this.productHandle &&
            productHandle !== 'undefined'
        );

      if (productHandlesArray.length === 0) {
        return;
      }

      productHandlesArray.forEach((productHandle, i) => {
        const addRecentProducts = async () => {
          try {
            const productCardResponse = await fetch(
              `${window.Shopify.routes.root}products/${productHandle}?view=card`
            );

            // Ürün artık mevcut değilse (silinmiş/yayından kaldırılmış) Shopify
            // isteği başka bir sayfaya (ör. ana sayfa) redirect edebilir. fetch()
            // bu redirect'i otomatik takip eder ve sonuç 200 OK döner, bu yüzden
            // `.ok` tek başına yeterli bir kontrol değil. Redirect olduysa bu
            // ürün kartı değil, tamamen farklı bir sayfanın HTML'idir; aynı
            // şekilde geçersiz sayıp temizliyoruz.
            if (!productCardResponse.ok || productCardResponse.redirected) {
              this.removeHandleFromStorage(productHandle);
              return;
            }

            const productCardHTML = await productCardResponse.text();

            const productSlide = document.createElement('DIV');

            productSlide.classList.add(
              'swiper-slide',
              'card-product-slider__slide'
            );
            productSlide.insertAdjacentHTML(
              'beforeend',
              productCardHTML
            );

            // Ekstra güvenlik: fetch edilen içerik gerçekten tekil bir ürün
            // kartı fragmanı olmalı, tam bir sayfa (header/nav/section) değil.
            // Redirect kontrolünü atlatan bir durum olursa bu ikinci kontrol
            // ana sayfa/başka bir sayfa içeriğinin slide'a eklenmesini engeller.
            const isFullPageMarkup = productSlide.querySelector(
              'header, nav, #shopify-section-header, .site-header'
            );

            if (
              isFullPageMarkup ||
              !productSlide.querySelector('product-card') ||
              !productSlide.querySelector('.product-card')
            ) {
              this.removeHandleFromStorage(productHandle);
              return;
            }

            this.sliderWrapper.append(productSlide);
          } catch (error) {
            // console.log(error);
          } finally {
            const isLastIteration =
              i === productHandlesArray.length - 1;

            if (!isLastIteration) {
              return;
            }

            this.initSlider();
            this.section?.classList.remove('hidden');
          }
        };

        addRecentProducts();
      });
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewed);
}